export const formatYearsOfManufacture = (startDate: string, endDate: string) => {
  let yearOfManufactureString = `${startDate} - ${endDate}`;
  if (!startDate && !endDate) {
    yearOfManufactureString = "-";
  } else if (!endDate) {
    yearOfManufactureString = `${startDate} - present`;
  }
  return yearOfManufactureString;
};
